<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h5>Ajouter Bon de Livraison stock</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="custom-search">
        <div class="row">
          <div class="col-md-9">
            <div class="form-group">
              <label>Agence :</label>
              <v-select :options="agencyList" v-model="agency" label="name" class="custom-select-height">
                <template v-slot:option="option">
                  <span>{{ option.name }} - {{ option.nb_colis }}</span>
                </template>
              </v-select>
            </div>
          </div>

          <b-col md="3">
            <b-button
              v-if="auth.can('ADD_BL_S')"
              variant="primary"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1 buttons"
              @click="addBLS"
              style="margin-top: 1.2rem;"
            >
              Ajouter
            </b-button>
          </b-col>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import router from "@/router";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;
    const agencyList = ref([]);
    const agency = ref(null);

    async function addBLS() {
      if (!agency.value || Object.keys(agency.value).length === 0) {
        showToast("Merci de remplir tous les champs.", "error");
        return;
      }

      try {
        let data = new FormData();
        data.append("agency_id", agency.value.id);
        data.append("agency_name", agency.value.name);
        data.append("agency_zone", agency.value.id_zone);
        data.append("user_name", user?.name || "");
        data.append("user_id", user?.id || "");

        // this.isLoader = true;
        const res = await api.post(`/api/auth/NewBL_S`, data);
        // this.isLoader = false;

        if (res.data.message === "success") {
          router.push({
            name: "EditNoteBLStockPage",
            params: {
              id: res.data.BLS.id,
              refNote: res.data.BLS.note_stock_ref,
            },
          });
        } else {
          showToast("Une erreur est survenue lors de la création du BL.", "error");
        }
      } catch (error) {
        // this.isLoader = false;
        showToast("Impossible de créer le BL. Veuillez réessayer.", "error");
        console.error(error);
      }
    }

    onMounted(async () => {
      // Fetch agency list or any initial data
      try {
        // Example API call to fetch agencies
        const response = await api.get("/api/auth/AgencyDelivery");
        agencyList.value = response.data;
      } catch (error) {
        showToast("Error fetching agencies", "error");
        console.error(error);
      }
    });



    return {
      agencyList,
      agency,
      addBLS,
      auth,
    };
  },
});
</script>
